exports = module.exports = require("../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".draftJsMentionPlugin__input__1Wxng {\n  height: 34px;\n  width: 220px;\n  padding: 0 12px;\n  font-size: 15px;\n  font-family: inherit;\n  background-color: transparent;\n  border: none;\n  color: #444;\n}\n\n.draftJsMentionPlugin__input__1Wxng:focus {\n  outline: none;\n}\n\n.draftJsMentionPlugin__input__1Wxng::-webkit-input-placeholder {\n  color: #888;\n}\n\n.draftJsMentionPlugin__input__1Wxng::-moz-placeholder {\n  color: #888;\n}\n\n.draftJsMentionPlugin__input__1Wxng:-ms-input-placeholder {\n  color: #888;\n}\n\n.draftJsMentionPlugin__input__1Wxng::placeholder {\n  color: #888;\n}\n\n.draftJsMentionPlugin__inputInvalid__X9hHv {\n  color: #e65757;\n}\n\n.draftJsMentionPlugin__link__TQHAX {\n  color: #2996da;\n  text-decoration: underline;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/draft-js-anchor-plugin/lib/plugin.css
// module id = 1611
// module chunks = 0